module.exports = __webpack_public_path__ + "img/myh.6828f9c0.png";